const SPACES = {
	FORM: 'change_password_form',
};

export default SPACES;
